import { useRef, useState, useEffect } from "react";
import { faCheck, faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from '../api/axios';
import background_img from '../assets/sign-in.jpg'
import { Link } from "@mui/material";
import { Button, Typography } from "@mui/material";

const CREATEACCOUNT_URL = '/create-account';

const USER_REGEX = /^[A-z][A-z0-9]{3,23}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{15,49}$/;
const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const EMAILPWD_REGEX = /^[A-z][A-z0-9]{8,50}$/;
const SECANSWERS_REGEX = /^[A-z\s][A-z0-9\s]{3,50}$/;

const securityQuestions = [
    "What was your childhood nickname?",
    "In what city did you meet your spouse/significant other?",
    "What is the name of your favorite childhood friend?",
    "What street did you live on in third grade?",
    "What is your oldest sibling's birthday month and year? (e.g., January 1900)",
    "What is the middle name of your youngest child?",
    "What is your oldest sibling's middle name?",
    "What school did you attend for sixth grade?",
    "What was your childhood phone number including area code? (e.g., 000-000-0000)",
    "What is your oldest cousin's first and last name?",
    "What was the name of your first stuffed animal?",
    "In what city or town did your mother and father meet?",
    "Where were you when you had your first kiss?",
    "What is the first name of the boy or girl that you first kissed?",
    "What was the last name of your third grade teacher?",
    "In what city does your nearest sibling live?",
    "What is your youngest brother's birthday month and year? (e.g., January 1900)",
    "What is your maternal grandmother's maiden name?",
    "In what city or town was your first job?",
    "What is the name of the place your wedding reception was held?",
    "What is the name of a college you applied to but didn't attend?",
    "Where were you when you first heard about 9/11?"
];


const CreateAccount = () => {
    useEffect(() => {
        document.title = 'Create Account';
    }, []);

    const userRef = useRef();
    const errRef = useRef();

    const [username, setUser] = useState('');
    const [validName, setValidName] = useState(false);
    const [userFocus, setUserFocus] = useState(false);

    const [password, setPwd] = useState('');
    const [validPwd, setValidPwd] = useState(false);
    const [pwdFocus, setPwdFocus] = useState(false);

    const [matchPwd, setMatchPwd] = useState('');
    const [validMatch, setValidMatch] = useState(false);
    const [matchFocus, setMatchFocus] = useState(false);

    const [email, setEmail] = useState('');
    const [validEmail, setValidEmail] = useState(false);
    const [emailFocus, setEmailFocus] = useState(false);

    const [emailPwd, setEmailPwd] = useState('');
    const [validEmailPwd, setValidEmailPwd] = useState(false);
    const [emailPwdFocus, setEmailPwdFocus] = useState(false);

    const [ans1, setAns1] = useState('');
    const [validAns1, setValidAns1] = useState(false);
    const [ans1Focus, setAns1Focus] = useState(false);

    const [ans2, setAns2] = useState('');
    const [validAns2, setValidAns2] = useState(false);
    const [ans2Focus, setAns2Focus] = useState(false);

    const [ans3, setAns3] = useState('');
    const [validAns3, setValidAns3] = useState(false);
    const [ans3Focus, setAns3Focus] = useState(false);

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    const [securityQuestion1, setSecurityQuestion1] = useState('');
    const [securityQuestion2, setSecurityQuestion2] = useState('');
    const [securityQuestion3, setSecurityQuestion3] = useState('');
    const [selectedQuestions, setSelectedQuestions] = useState([]);

    // function to handle security question selection
    const handleQuestionSelection = (e, setQuestion) => {
        const selectedOption = e.target.value;
        setQuestion(selectedOption);
        setSelectedQuestions([...selectedQuestions, selectedOption]);
    }

    useEffect(() => {
        userRef.current.focus();
    }, [])

    useEffect(() => {
        setValidName(USER_REGEX.test(username));
    }, [username])

    useEffect(() => {
        setValidPwd(PWD_REGEX.test(password));
        setValidMatch(password === matchPwd);
    }, [password, matchPwd])

    useEffect(() => {
        setValidEmail(EMAIL_REGEX.test(email));
    }, [email])

    useEffect(() => {
        setValidEmailPwd(EMAILPWD_REGEX.test(emailPwd));
    }, [emailPwd])

    useEffect(() => {
        setValidAns1(SECANSWERS_REGEX.test(ans1));
    }, [ans1])

    useEffect(() => {
        setValidAns2(SECANSWERS_REGEX.test(ans2));
    }, [ans2])

    useEffect(() => {
        setValidAns3(SECANSWERS_REGEX.test(ans3));
    }, [ans3])

    useEffect(() => {
        setErrMsg('');
    }, [username, password, matchPwd, email, emailPwd, ans1, ans2, ans3])

    const handleSubmit = async (e) => {
        e.preventDefault();
        // if button enabled with JS hack
        const v1 = USER_REGEX.test(username);
        const v2 = PWD_REGEX.test(password);
        const v3 = EMAIL_REGEX.test(email);
        const v4 = EMAILPWD_REGEX.test(emailPwd)
        const v5 = SECANSWERS_REGEX.test(ans1)
        const v6 = SECANSWERS_REGEX.test(ans2)
        const v7 = SECANSWERS_REGEX.test(ans3)
        if (!v1 || !v2 || !v3 || !v4 || !v5 || !v6 || !v7) {
            setErrMsg("Invalid Entry");
            return;
        }
        try {
            const response = await axios.post(CREATEACCOUNT_URL,
                JSON.stringify({
                    username: username, password: password,
                    primary_email: email, primary_email_password: emailPwd,
                    security_questions: JSON.stringify({
                        "Question 1": securityQuestion1,
                        "Answer 1": ans1,
                        "Question 2": securityQuestion2,
                        "Answer 2": ans2,
                        "Question 3": securityQuestion3,
                        "Answer 3": ans3
                    })
                }),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                }
            );
            console.log(response?.data);
            console.log(response?.accessToken);
            console.log(JSON.stringify(response))
            setSuccess(true);
            //clear state and controlled inputs
            //need value attrib on inputs for this
            setUser('');
            setPwd('');
            setMatchPwd('');
            setEmail('');
            setEmailPwd('');
            setSecurityQuestion1('');
            setAns1('');
            setSecurityQuestion2('');
            setAns2('');
            setSecurityQuestion3('');
            setAns3('');

        } catch (err) {
            if (!err?.response) {
                setErrMsg('No Server Response');
            } else if (err.response?.status === 409) {
                setErrMsg('Username Taken');
            } else {
                setErrMsg('Account Creation Failed')
            }
            errRef.current.focus();
        }
    }

    return (
        <div style={{
            backgroundImage: `url(${background_img})`,
            backgroundRepeat: "no",
            backgroundSize: "cover"
        }}>
            <div style={{ height: "20vh" }}>
            </div>
            {success ? (
                <section>
                    <h1>Success!</h1>
                    <p>
                        <a href="sign-in">Sign In</a>
                    </p>
                </section>
            ) : (
                <section style={{ marginRight: "12%", }}
                >
                    <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
                    <h1>Create Account</h1>
                    <form onSubmit={handleSubmit}>
                        <label style={{ marginTop: '1rem' }} htmlFor="username">
                            Username:
                            <FontAwesomeIcon icon={faCheck} className={validName ? "valid" : "hide"} />
                            <FontAwesomeIcon icon={faTimes} className={validName || !username ? "hide" : "invalid"} />
                        </label>
                        <input
                            type="text"
                            id="username"
                            ref={userRef}
                            autoComplete="off"
                            onChange={(e) => setUser(e.target.value)}
                            value={username}
                            required
                            aria-invalid={validName ? "false" : "true"}
                            aria-describedby="uidnote"
                            onFocus={() => setUserFocus(true)}
                            onBlur={() => setUserFocus(false)}
                        />
                        <p id="uidnote" className={userFocus && username && !validName ? "instructions" : "offscreen"}>
                            <FontAwesomeIcon icon={faInfoCircle} />
                            4 to 24 characters.<br />
                            Must begin with a letter.<br />
                            Letters and numbers only.
                        </p>


                        <label style={{ marginTop: '1rem' }} htmlFor="password">
                            Password:
                            <FontAwesomeIcon icon={faCheck} className={validPwd ? "valid" : "hide"} />
                            <FontAwesomeIcon icon={faTimes} className={validPwd || !password ? "hide" : "invalid"} />
                        </label>
                        <input
                            type="password"
                            id="password"
                            onChange={(e) => setPwd(e.target.value)}
                            value={password}
                            required
                            aria-invalid={validPwd ? "false" : "true"}
                            aria-describedby="pwdnote"
                            onFocus={() => setPwdFocus(true)}
                            onBlur={() => setPwdFocus(false)}
                        />
                        <p id="pwdnote" className={pwdFocus && !validPwd ? "instructions" : "offscreen"}>
                            <FontAwesomeIcon icon={faInfoCircle} />
                            16 to 50 characters.<br />
                            Must include uppercase and lowercase letters, and a number.<br />

                        </p>


                        <label style={{ marginTop: '1rem' }} htmlFor="confirm_pwd">
                            Confirm Password:
                            <FontAwesomeIcon icon={faCheck} className={validMatch && matchPwd ? "valid" : "hide"} />
                            <FontAwesomeIcon icon={faTimes} className={validMatch || !matchPwd ? "hide" : "invalid"} />
                        </label>
                        <input
                            type="password"
                            id="confirm_pwd"
                            onChange={(e) => setMatchPwd(e.target.value)}
                            value={matchPwd}
                            required
                            aria-invalid={validMatch ? "false" : "true"}
                            aria-describedby="confirmnote"
                            onFocus={() => setMatchFocus(true)}
                            onBlur={() => setMatchFocus(false)}
                        />
                        <p id="confirmnote" className={matchFocus && !validMatch ? "instructions" : "offscreen"}>
                            <FontAwesomeIcon icon={faInfoCircle} />
                            Must match the first password input field.
                        </p>

                        <label style={{ marginTop: '1rem' }} htmlFor="email">
                            Primary Email:
                            <FontAwesomeIcon icon={faCheck} className={validEmail ? "valid" : "hide"} />
                            <FontAwesomeIcon icon={faTimes} className={validEmail || !email ? "hide" : "invalid"} />
                        </label>
                        <input
                            type="text"
                            id="email"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                            required
                            aria-invalid={validEmail ? "false" : "true"}
                            aria-describedby="emailnote"
                            onFocus={() => setEmailFocus(true)}
                            onBlur={() => setEmailFocus(false)}
                        />
                        <p id="emailnote" className={emailFocus && !validEmail ? "instructions" : "offscreen"}>
                            <FontAwesomeIcon icon={faInfoCircle} />
                            Please enter your primary email to send emails to and from.
                        </p>

                        <label style={{ marginTop: '1rem' }} htmlFor="emailPwd">
                            Primary Email 3rd Party Password:
                            <FontAwesomeIcon icon={faCheck} className={validEmailPwd ? "valid" : "hide"} />
                            <FontAwesomeIcon icon={faTimes} className={validEmailPwd || !emailPwd ? "hide" : "invalid"} />
                        </label>
                        <input
                            type="password"
                            id="emailPwd"
                            onChange={(e) => setEmailPwd(e.target.value)}
                            value={emailPwd}
                            required
                            aria-invalid={validEmailPwd ? "false" : "true"}
                            aria-describedby="emailpwdnote"
                            onFocus={() => setEmailPwdFocus(true)}
                            onBlur={() => setEmailPwdFocus(false)}
                        />
                        <p id="emailpwdnote" className={emailPwdFocus && !validEmailPwd ? "instructions" : "offscreen"}>
                            <FontAwesomeIcon icon={faInfoCircle} />
                            This password was given to you from your email provider.
                        </p>






                        <label style={{ marginTop: '1rem' }} htmlFor="securityQuestion1">
                            Security Question 1:
                            <FontAwesomeIcon icon={faCheck} className="hide" />
                            <FontAwesomeIcon icon={faTimes} className="hide" />
                        </label>
                        <select
                            id="securityQuestion1"
                            name="securityQuestion1"
                            value={securityQuestion1}
                            style={{ height: '50px', fontSize: 20, whiteSpace: 'normal' }}
                            onChange={e => handleQuestionSelection(e, setSecurityQuestion1)}
                        >
                            <option value="" disabled>
                                Security Question 1
                            </option>
                            {securityQuestions.map((question, index) => (
                                <option key={index} value={question}>
                                    {question}
                                </option>
                            ))}
                        </select>

                        <label style={{ marginTop: '1rem' }} htmlFor="ans1">
                            Answer 1:
                            <FontAwesomeIcon icon={faCheck} className={validAns1 ? "valid" : "hide"} />
                            <FontAwesomeIcon icon={faTimes} className={validAns1 || !ans1 ? "hide" : "invalid"} />
                        </label>
                        <input
                            type="text"
                            id="ans1"
                            autoComplete="off"
                            onChange={(e) => setAns1(e.target.value)}
                            value={ans1}
                            required
                            aria-invalid={validAns1 ? "false" : "true"}
                            aria-describedby="ans1note"
                            onFocus={() => setAns1Focus(true)}
                            onBlur={() => setAns1Focus(false)}
                        />
                        <p id="ans1note" className={ans1Focus && ans1 && !validAns1 ? "instructions" : "offscreen"}>
                            <FontAwesomeIcon icon={faInfoCircle} />
                            Letters and numbers (and spaces) only.
                        </p>




                        <label style={{ marginTop: '1rem' }} htmlFor="securityQuestion2">
                            Security Question 2:
                            <FontAwesomeIcon icon={faCheck} className="hide" />
                            <FontAwesomeIcon icon={faTimes} className="hide" />
                        </label>
                        <select
                            id="securityQuestion2"
                            name="securityQuestion2"
                            value={securityQuestion2}
                            style={{ height: '50px', fontSize: 20, whiteSpace: 'normal' }}
                            onChange={e => handleQuestionSelection(e, setSecurityQuestion2)}
                        >
                            <option value="" disabled>
                                Security Question 2
                            </option>
                            {securityQuestions.map((question, index) => (
                                <option key={index} value={question}>
                                    {question}
                                </option>
                            ))}
                        </select>

                        <label style={{ marginTop: '1rem' }} htmlFor="ans2">
                            Answer 2:
                            <FontAwesomeIcon icon={faCheck} className={validAns2 ? "valid" : "hide"} />
                            <FontAwesomeIcon icon={faTimes} className={validAns2 || !ans2 ? "hide" : "invalid"} />
                        </label>
                        <input
                            type="text"
                            id="ans2"
                            autoComplete="off"
                            onChange={(e) => setAns2(e.target.value)}
                            value={ans2}
                            required
                            aria-invalid={validAns2 ? "false" : "true"}
                            aria-describedby="ans2note"
                            onFocus={() => setAns2Focus(true)}
                            onBlur={() => setAns2Focus(false)}
                        />
                        <p id="ans2note" className={ans2Focus && ans2 && !validAns2 ? "instructions" : "offscreen"}>
                            <FontAwesomeIcon icon={faInfoCircle} />
                            Letters and numbers (and spaces) only.
                        </p>




                        <label style={{ marginTop: '1rem' }} htmlFor="securityQuestion3">
                            Security Question 3:
                            <FontAwesomeIcon icon={faCheck} className="hide" />
                            <FontAwesomeIcon icon={faTimes} className="hide" />
                        </label>
                        <select
                            id="securityQuestion3"
                            name="securityQuestion3"
                            value={securityQuestion3}
                            style={{ height: '50px', fontSize: 20, whiteSpace: 'normal' }}
                            onChange={e => handleQuestionSelection(e, setSecurityQuestion3)}
                        >
                            <option value="" disabled>
                                Security Question 3
                            </option>
                            {securityQuestions.map((question, index) => (
                                <option key={index} value={question}>
                                    {question}
                                </option>
                            ))}
                        </select>

                        <label style={{ marginTop: '1rem' }} htmlFor="ans3">
                            Answer 3:
                            <FontAwesomeIcon icon={faCheck} className={validAns3 ? "valid" : "hide"} />
                            <FontAwesomeIcon icon={faTimes} className={validAns3 || !ans3 ? "hide" : "invalid"} />
                        </label>
                        <input
                            type="text"
                            id="ans3"
                            autoComplete="off"
                            onChange={(e) => setAns3(e.target.value)}
                            value={ans3}
                            required
                            aria-invalid={validAns3 ? "false" : "true"}
                            aria-describedby="ans3note"
                            onFocus={() => setAns3Focus(true)}
                            onBlur={() => setAns3Focus(false)}
                        />
                        <p id="ans3note" className={ans3Focus && ans3 && !validAns3 ? "instructions" : "offscreen"}>
                            <FontAwesomeIcon icon={faInfoCircle} />
                            Letters and numbers (and spaces) only.
                        </p>
                        <Button
                            disabled={!validName || !validPwd || !validMatch || !validEmail || !validEmailPwd || !validAns1 ||
                                !validAns2 || !validAns3 ? true : false}
                            onClick={handleSubmit}
                            variant="contained" style={{ marginTop: 20, marginBottom: 0 }}>
                            Sign Up
                        </Button>
                        {/* <button disabled={!validName || !validPwd || !validMatch || !validEmail || !validEmailPwd || !validAns1 ||
                            !validAns2 || !validAns3 ? true : false}>Sign Up</button> */}
                    </form>
                    <p>
                        <Link style={{ color: "#ffffff" }}>

                            <span className="line">
                                <a href="sign-in" style={{ color: "#2477c5" }}>
                                    <Typography
                                        variant="h20"
                                        color="#2477c5"
                                        fontWeight="bold"
                                        sx={{ m: "0 0 2px 3px" }}
                                    >
                                        Already registered?
                                    </Typography>
                                    <br />
                                </a>
                            </span>
                        </Link>
                    </p>
                </section>

            )
            }
            <div style={{ height: "35vh" }}>
            </div>
        </div >
    )
}

export default CreateAccount